import { Navigate, type RouteObject } from "react-router";
import { RequireAdmin, SignedIn } from "@/auth/guards";
import { AdminBlogPage } from "./blog/AdminBlog";
import { BlogListPage, BlogPostPage } from "./blog/BlogPages";
import { PrivacyPage } from "./legal/Privacy";
import { TermsPage } from "./legal/Terms";
import { ROUTES } from "./links";
import { ContactPage } from "./pages/Contact";
import { EmployersPage } from "./pages/Employers";
import { HomePage } from "./pages/Home";
import { HowItWorksPage } from "./pages/HowItWorks";
import { SiteNotFoundPage } from "./pages/NotFound";
import { PricingPage } from "./pages/Pricing";
import { SecurityPage } from "./pages/Security";
import { TeamPage } from "./pages/Team";
import { WhatAbiDoesPage } from "./pages/WhatAbiDoes";
import { SiteLayout } from "./SiteLayout";

/**
 * The marketing site, legal pages and blog, mounted at the root next to the app's routes
 * (src/app/router.tsx). Everything public renders inside SiteLayout (the dark `#site` frame).
 *
 * The site's `*` route is the 404 for any path the app doesn't own; react-router ranks it with the
 * app's own `*` by order, and siteRoutes come first.
 *
 * Not registered on purpose: the Seminars draft in ./drafts (see its README).
 */
export const siteRoutes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: ROUTES.how.slice(1), element: <HowItWorksPage /> },
      { path: ROUTES.employers.slice(1), element: <EmployersPage /> },
      { path: ROUTES.abi.slice(1), element: <WhatAbiDoesPage /> },
      { path: ROUTES.security.slice(1), element: <SecurityPage /> },
      { path: ROUTES.pricing.slice(1), element: <PricingPage /> },
      { path: ROUTES.team.slice(1), element: <TeamPage /> },
      { path: "blog", element: <BlogListPage /> },
      { path: "blog/:slug", element: <BlogPostPage /> },
      { path: ROUTES.terms.slice(1), element: <TermsPage /> },
      { path: ROUTES.privacy.slice(1), element: <PrivacyPage /> },
      { path: ROUTES.contact.slice(1), element: <ContactPage /> },
      // The legacy site's /about was "How it helps".
      { path: "about", element: <Navigate to={ROUTES.how} replace /> },
      { path: "*", element: <SiteNotFoundPage /> },
    ],
  },
  {
    path: "admin/blog",
    element: (
      <SignedIn>
        <RequireAdmin allowBlogAdmin>
          <AdminBlogPage />
        </RequireAdmin>
      </SignedIn>
    ),
  },
];
